import React from 'react';
import { BookOpen, Target, Activity, Brain, Lightbulb } from 'lucide-react';

const KNOWLEDGE_BASE = [
  { id: 1, title: "YKS Nedir?", icon: BookOpen, desc: "TYT ve AYT oturumlarından oluşur.", category: "Sınav Sistemi" },
  { id: 2, title: "Verimli Çalışma", icon: Target, desc: "Pomodoro tekniği (25+5) odaklanmayı artırır.", category: "Rehberlik" },
  { id: 3, title: "Sınav Kaygısı", icon: Activity, desc: "Nefes egzersizleri ile kaygıyı yönetin.", category: "Psikoloji" },
  { id: 4, title: "Mindfulness", icon: Brain, desc: "Bilinçli farkındalık; an'da kalabilme becerisidir.", category: "Egzersiz" },
  { id: 5, title: "Alan Seçimi", icon: Lightbulb, desc: "Sayısal, Eşit Ağırlık, Sözel ve Dil alanları.", category: "Kariyer" },
];

const KnowledgeBase = () => { 
  return (
    <div className="space-y-8 no-print">
      <h2 className="text-3xl font-black text-slate-800">Bilgi Köşesi</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {KNOWLEDGE_BASE.map(item => (
          <div key={item.id} className="bg-white p-6 rounded-2xl border border-slate-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-default group">
            <div className="h-12 w-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                <item.icon className="h-6 w-6"/>
            </div>
            <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">{item.category}</span>
            <h3 className="text-xl font-bold text-slate-900 mt-1 mb-3">{item.title}</h3>
            <p className="text-sm text-slate-500 leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  ); 
};

export default KnowledgeBase;